import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'avn/services/api.service';
import { SharedCompsService } from 'avn/shared/shared-comps.service';

@Component({
  selector: 'app-exit-intent',
  templateUrl: './exit-intent.component.html',
  styleUrls: ['./exit-intent.component.scss']
})
export class ExitIntentComponent implements OnInit {
  hasSubmitted = false;
  claimNumber: any = '';
  service: any = '';
  constructor(
    private dialogRef: MatDialogRef<ExitIntentComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private api: ApiService,
    private router: Router,
    private shared: SharedCompsService
  ) {}

  // Input property to control visibility of exit intent modal
  @Input() showExitIntentModal: boolean;

  existOptions = [
    'No Practitioners close enough to me',
    'No times that suit my schedule',
    'I’m just researching my options',
    'I need more information about this platform',
    'Other reason'
  ];

  ngOnInit(): void {
    this.claimNumber = localStorage.getItem('claim_number');
    this.service = localStorage.getItem('service');
  }

  // Listen for the 'beforeunload' event (triggered when user tries to leave the page)
  @HostListener('window:beforeunload', ['$event'])
  handleExitIntent(event: any): void {
    if (!this.hasSubmitted) {
      // Prevent default page unload and show browser confirmation dialog
      event.preventDefault();
      event.returnValue = '';

      // this.http.post('/api/exit-intent-feedback', { reason: 'User left the page' }).subscribe();

      this.hasSubmitted = true;
    }
  }

  // Close the exit intent modal
  closeModal(): void {
    this.dialogRef.close();
  }

  // Capture the reason selected by the user and redirect to home
  selectReason(reason: string): void {
    console.info(reason);
    const params = {
      claim_number: this.claimNumber,
      modality: this.service,
      drop_off_reason: reason
    };

    const responseObs = this.api.exitIntent(params);
    responseObs.subscribe({
      next: (response) => {
        console.info('response', response);
        this.dialogRef.close(params);
        // this.router.navigate(['/']);
      },
      error: (error) => {
        console.info(error);
        this.shared.showSnackBar(error?.error.message, 3);
      }
    });
  }
}
